export default __webpack_public_path__ + "1.19.4/static/media/LibreDataSharecode_Japanese.30f658c9.svg";